import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Row } from "react-bootstrap"
import { Link } from 'react-router-dom';
import { ChoiceGroup } from '@fluentui/react/lib/ChoiceGroup';

import '../../css/ProfileCard.css'

const ProfileCard = (props) => {

    const { t } = useTranslation();

    const showEditProfile = false;
    const selectionModeEnabled = props.selectionModeEnabled !== null && props.selectionModeEnabled !== undefined ? props.selectionModeEnabled : false;
    const total_label = props.totalLabel;


    return (
        <>   
            <Card style={{width : "300px"}} className={`m-2 card-profile-role ${props.selectedRoleId === props.id ? "m-2 card-profile-role-selected" : ""}`}>
                <Card.Title className="card-client-profile-title">
                    {total_label.replace("##", props.counter)}
                    <p className="float-end">
                        { showEditProfile &&
                            <Link exact="true" to={{ pathname: '/editclient', state: 0 }}><b>-</b></Link>
                        }
                    </p>
                </Card.Title>
                <Card.Body className="col-xs-12 card-client-profile-body">
                    <Row>
                        <h5>{props.name}</h5>
                    </Row>
                    <Row className="pt-2">
                        { selectionModeEnabled === true && 
                            <ChoiceGroup key={props.id} options={[{ key: props.id, text: props.name, value: props.id }]} selectedKey={props.selectedRoleId} onClick={props.onChangeCard} /*onChange={props.onChangeCard}*/ />
                        }
                        { selectionModeEnabled === false && 
                            <Link className="card-client-profile-link" exact="true" to={{ pathname: '/listusers', state: { clientId: props.clientId, authRoleName: props.name } }}>{t('data-lang-lbl-viewusers')}</Link>
                        }
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};

export default ProfileCard;